/*
 * This code is the intellectual property of Bulb Inc. and other software publishers;
 * it may not be altered, copied or disclosed without prior written approval.
 * Copyright 2015-2022, Bulb Inc.  For more information, please email contact@hellobulb.com.
 */

angular.module('bulbApp.jwplayerModule', ['bulbApp.errorModule'])

  .constant('JWPLAYER', {
    defaultOptions: {
      autostart: false,
      controls: true,
      displaydescription: false,
      displaytitle: false,
      height: '100%',
      mute: false,
      ph: 1,
      primary: 'html5',
      repeat: false,
      stagevideo: false,
      stretching: 'uniform',
      visualplaylist: false,
      width: '100%',
      timeout: 250,
    },
  });
